import useSessionStorage from 'react-use/lib/useSessionStorage';

export type OIDCAuthorizationState = {
    type: 'AUTH' | 'END_SESSION';
    state: string;
    forwardUrl: string;
    rewindUrl?: string;
    codeVerifier?: string;
};

const AUTH_STATE_KEY = 'jp.tier4.drive.autoware.auth.oidc.state';

export function useAuthorizationState() {
    const [authState, setAuthState] = useSessionStorage<OIDCAuthorizationState | null>(AUTH_STATE_KEY, null);
    return { authState, setAuthState };
}
